import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    components: {
      default: HomeView
    },
    children: [
      {
        path: '',
        name: 'DashboardItem',
        components: {
          dashboard: () => import('../views/DashboardItem.vue')
        }
      },
      {
        path: '/agents',
        name: 'AgentsItem',
        components: {
          dashboard: () => import('../views/AgentsItem.vue')
        }
      },
      {
        path: '/properties',
        name: 'PropertiesItem',
        components: {
          dashboard: () => import('../views/PropertyManagement.vue')
        }
      },
      {
        path: '/properties/:id',
        name: 'PropertyDetails',
        components: {
          dashboard: () => import('../views/PropertyDetails.vue')
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'LoginItem',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
